import React from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { RecuperacaoMarcacao } from '../api/cccApi';
import CccWorkspaceDuplicateIndicator, {
  type CccWorkspaceDuplicateFlags,
} from './CccWorkspaceDuplicateIndicator';
import { buildInvestigateQuickSearchSeed } from '../utils/recuperacaoMarcacaoDisplay';

type Props = {
  marcacao: RecuperacaoMarcacao;
  onClaim?: () => void;
  claiming?: boolean;
  onQuickInvestigate?: (seed: ReturnType<typeof buildInvestigateQuickSearchSeed>) => void;
  duplicateFlags?: CccWorkspaceDuplicateFlags | null;
};

const RecuperacaoMarcacaoCard: React.FC<Props> = ({
  marcacao,
  onClaim,
  claiming,
  onQuickInvestigate,
  duplicateFlags,
}) => {
  const empresa = marcacao.nome_empresa || 'Sem empresa';
  const showPedidoTag =
    marcacao.has_comercial_pedido === true ||
    (Array.isArray(marcacao.pool_tags) && marcacao.pool_tags.includes('P'));

  return (
    <div className="rec-queue-item-row">
      <button
        type="button"
        className="rec-queue-item"
        disabled={claiming}
        onClick={onClaim}
        title={claiming ? 'A iniciar…' : `Iniciar: ${empresa}`}
      >
        <span className="rec-queue-item-name">
          {showPedidoTag ? (
            <span className="rec-pool-tag-p" title="Pedido de proposta (Comercial)">
              P
            </span>
          ) : null}
          {empresa}
          <CccWorkspaceDuplicateIndicator flags={duplicateFlags} />
        </span>
        {claiming ? (
          <span className="rec-queue-item-spinner" aria-label="A iniciar" />
        ) : (
          <span className="rec-queue-item-action">Iniciar</span>
        )}
      </button>
      {onQuickInvestigate ? (
        <button
          type="button"
          className="rec-quick-investigate-btn rec-quick-investigate-btn--pool"
          title="Pesquisa rápida — Investigar por empresa e contacto"
          aria-label={`Pesquisa rápida: ${empresa}`}
          onClick={() => onQuickInvestigate(buildInvestigateQuickSearchSeed(marcacao))}
        >
          <SearchOutlined />
        </button>
      ) : null}
    </div>
  );
};

export default RecuperacaoMarcacaoCard;
